import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Center, Image, Button } from "@chakra-ui/react";

import { Lang } from "@noli/core";
import { langStore, translate } from "@noli/business";

import "./Popup.scss";
import { genBlock } from "@/utils/bem";
import { themeStore } from "@/stores/theme";
import CommunityImage from "@/assets/images/qrcodes/community.png";
import CoffeeImage from "@/assets/images/qrcodes/coffee.png";
import { ReactComponent as EmailSvg } from "@/assets/icons/email.svg";
import { ReactComponent as GitHubSvg } from "@/assets/icons/github.svg";
import Icon from "@/components/Icon";
import Link from "@/components/Link";
import { Editor_Words } from "@/utils/lang/editor";

const block = genBlock("c-contact-us-popup");

const Separator = observer(() => {
  const { separatorColor } = themeStore.styles;
  return (
    <Center pt="24px">
      <Box w="80%" h="0px" borderTop="2px" borderColor={separatorColor}></Box>
    </Center>
  );
});

const ZhPopup = observer(() => {
  return (
    <Box w="100%" h="410px">
      <Center pt="24px" fontSize="12px">
        {translate(Editor_Words["join-community-message"], "zh")}
      </Center>
      <Center pt="16px">
        <Image w="120px" borderRadius="4px" src={CommunityImage} />
      </Center>
      <Separator />
      <Box my="14px"></Box>
      <Link
        text="📖 画宇宙帮助文档"
        url="https://f8y4v1rln8.feishu.cn/wiki/wikcna7VCVJOxmTeVmQY5Jj0nSf"
      />
      <Link
        text="💾 产品使用方法"
        url="https://f8y4v1rln8.feishu.cn/wiki/wikcnlHLIsZUOnYsCQc3YQUMA4e"
      />
      <Link
        text="🎬 功能入门视频"
        url="https://f8y4v1rln8.feishu.cn/wiki/wikcnqpuy8GNgsW9rGg418LESmf"
      />
      <Link
        text="💡 关键词（Prompt）知识"
        url="https://f8y4v1rln8.feishu.cn/wiki/wikcn5OQ4fzUol32sJ0jV0zjSxd"
      />
      <Link
        text="🌟 私有化部署 🔥"
        url="https://f8y4v1rln8.feishu.cn/wiki/wikcnIbD4EhOkuk4baag1T21cX9"
      />
      <Link
        text="©️ 版权声明"
        url="https://f8y4v1rln8.feishu.cn/wiki/wikcnC8le94X75xzdXDIWyBpIxc"
      />
    </Box>
  );
});

const EnPopup = observer(() => {
  return (
    <Box w="100%" h="260px">
      <Center pt="24px" fontSize="12px">
        {translate(Editor_Words["visit-github-message"], "en")}
      </Center>
      <Center pt="16px" mb="4px">
        <Button
          w="70%"
          variant="outline"
          as="a"
          href="https://github.com/carefree0910/carefree-creator"
          target="_blank"
        >
          <Icon svg={GitHubSvg} className={block({ e: "icon" })} />
        </Button>
      </Center>
      <Separator />
      <Center pt="24px" fontSize="12px">
        {translate(Editor_Words["email-author-message"], "en")}
      </Center>
      <Center pt="16px">
        <Button w="70%" variant="outline" as="a" href="mailto: syameimaru.saki@gmail.com">
          <Icon svg={EmailSvg} className={block({ e: "icon" })} />
        </Button>
      </Center>
    </Box>
  );
});

const ContactUsPopup: React.FC<{ className?: string }> = ({ className }) => {
  const lang = langStore.tgt;
  const { panelBg, captionColor } = themeStore.styles;

  return (
    <Box
      className={className}
      w="272px"
      bg={panelBg}
      color={captionColor}
      boxShadow="0px 0px 8px rgba(0, 0, 0, 0.25);"
    >
      {lang === "zh" ? <ZhPopup /> : <EnPopup />}
    </Box>
  );
};

export default observer(ContactUsPopup);
